import { render, staticRenderFns } from "./cencenlInterview.vue?vue&type=template&id=2f921e32&scoped=true"
import script from "./cencenlInterview.vue?vue&type=script&lang=js"
export * from "./cencenlInterview.vue?vue&type=script&lang=js"
import style0 from "./cencenlInterview.vue?vue&type=style&index=0&id=2f921e32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f921e32",
  null
  
)

export default component.exports